import { apiClient } from '../api/apiClient';

export const profileService = {
    getProfile() {
        return apiClient.get('user/profile');
    },

    getPublicProfileById(friendId) {
        return apiClient.get(`user/public-profile/by-id/${friendId}`);
    },

    getPublicProfileByUsername(username) {
        return apiClient.get(`user/public-profile/by-username/${encodeURIComponent(username)}`);
    },

    updateProfile(payload) {
        return apiClient.post('user/updateProfile', { json: payload });
    },

    uploadProfilePicture(formData) {
        return apiClient.post('user/upload-profile-picture', {
            body: formData
        });
    },

    getMemberPass() {
        return apiClient.get('user/member-pass');
    },

    getMemberPassWallet() {
        return apiClient.get('user/member-pass/wallet');
    }
};
